import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { LiveDocumentAccessLostIndicator } from 'pages/chatbot/ui/LiveDocumentAccessLostIndicator/LiveDocumentAccessLostIndicator'
import styles from './styles.module.scss'

type DocumentDropdownLabelProps = {
  name: string
  isAccessLost: boolean
}

export const DocumentDropdownLabel = observer(
  ({ name, isAccessLost }: DocumentDropdownLabelProps) => (
    <div className={styles.documentDropdownLabel}>
      <Typography
        ellipsis
        variant={'body-md-regular'}
        className={styles.documentDropdownLabelText}
        tooltipProps={{
          label: name,
          placement: 'top',
        }}
        ariaLabel={'documentName'}
      >
        {name}
      </Typography>
      {isAccessLost && <LiveDocumentAccessLostIndicator />}
    </div>
  )
)
